import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV } from "../lib/data";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-ink/80 backdrop-blur-xl border-b border-line" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <button data-testid="logo-link" onClick={() => go("#top")} className="flex items-center gap-3 group">
          <img src="/logo.png" alt="Goose the Gander" className="h-12 w-12 object-contain" />
          <span className="font-serif text-xl sm:text-2xl tracking-tight text-bone group-hover:text-brass transition-colors leading-none">
            Goose <span className="text-mute font-body text-xs uppercase tracking-[0.25em] hidden sm:inline">the Gander</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <button
              key={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              onClick={() => go(n.href)}
              className="font-mono text-xs uppercase tracking-[0.18em] text-mute hover:text-bone transition-colors"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="nav-apply"
            onClick={() => go("#apply")}
            className="font-mono text-xs uppercase tracking-[0.18em] bg-brass text-ink px-5 py-2.5 hover:bg-bone transition-colors"
          >
            Apply
          </button>
        </nav>

        <button data-testid="mobile-menu-toggle" className="md:hidden text-bone" onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-ink border-b border-line"
          >
            <div className="px-5 py-6 flex flex-col gap-5">
              {NAV.map((n) => (
                <button key={n.href} data-testid={`mobile-nav-${n.label.toLowerCase()}`} onClick={() => go(n.href)} className="font-mono text-sm uppercase tracking-[0.18em] text-mute text-left">
                  {n.label}
                </button>
              ))}
              <button data-testid="mobile-nav-apply" onClick={() => go("#apply")} className="font-mono text-xs uppercase tracking-[0.18em] bg-brass text-ink px-5 py-3">
                Apply to trade
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
